import React, { ChangeEvent, ReactNode } from 'react';

type ButtonPropTypes = {
  buttonText: string;
  className?: string;
  isDisabled?: boolean;
  type?: 'submit' | 'button' | 'reset';
  icon?: ReactNode;
  size?: 'small' | 'medium';
  ariaHidden?: boolean;
  onClickHandler?: (event: React.FormEvent<HTMLFormElement> | ChangeEvent<EventTarget>) => void;
};

/**
 * Presentational common Button component
 */
function Button(props: ButtonPropTypes) {
  const { onClickHandler, isDisabled, type, buttonText, icon, size, className, ariaHidden } = props;

  return (
    <button
      type={type}
      className={`items-center disabled:bg-gray99 bg-accent-blue border border-solid py-space-1 md:py-space-2 ${
        size === 'small' ? 'px-space-3' : 'px-space-3 md:px-space-6'
      } text-white rounded-md text-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-blue ${className}`}
      onClick={onClickHandler}
      disabled={Boolean(isDisabled)}
      aria-hidden={ariaHidden}
    >
      {buttonText} {icon}
    </button>
  );
}

export default Button;
